import { render } from "./FormMaengelliste.vue?vue&type=template&id=a3e3f62a"
import script from "./FormMaengelliste.vue?vue&type=script&lang=js"
export * from "./FormMaengelliste.vue?vue&type=script&lang=js"

import exportComponent from "/home/hiro/lab/hands4you-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__